(function () {
  var loaderUrl = 'https://block.lokol.ai/v1/lokol.js';
  var reloadTimer = null;

  function hasFreshBlock(root) {
    if (!root || root.nodeType !== 1) return false;
    if (root.matches && root.matches('[data-lokol-block]:not([data-ap-lokol-loading])') && !root.shadowRoot) return true;
    return !!(root.querySelector && root.querySelector('[data-lokol-block]:not([data-ap-lokol-loading])'));
  }

  function hydrateFreshBlocks() {
    var blocks = Array.prototype.filter.call(
      document.querySelectorAll('[data-lokol-block]:not([data-ap-lokol-loading])'),
      function (block) { return !block.shadowRoot; }
    );
    if (!blocks.length) return;

    blocks.forEach(function (block) { block.setAttribute('data-ap-lokol-loading', 'true'); });
    var script = document.createElement('script');
    script.src = loaderUrl;
    script.async = true;
    script.onload = script.onerror = function () {
      blocks.forEach(function (block) { block.removeAttribute('data-ap-lokol-loading'); });
      script.remove();
    };
    document.head.appendChild(script);
  }

  var observer = new MutationObserver(function (records) {
    var found = records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, hasFreshBlock);
    });
    if (!found) return;
    clearTimeout(reloadTimer);
    reloadTimer = setTimeout(hydrateFreshBlocks, 100);
  });

  function start() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
